import React from 'react'
import UniversalModal from '@/modules/banking/components/universal-modal/universal-modal'
import { TransactionCanceled } from '@/modules/banking/errors'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openUniversalModal = ({ transaction, onSuccess, onError, onAbort = () => { } }) => {
  const { transactionId } = transaction

  return new Promise((resolve, reject) => {
    const getComponent = (close) => {
      return (
        <div data-transaction-id={transactionId}>
          <UniversalModal
            open={true}
            transaction={transaction}
            onSuccess={(data) => {
              close()
              onSuccess(data)
              resolve(data)
            }}
            onError={(error) => {
              close()
              onError(error)
              reject(error)
            }}
            onAbort={() => {
              close()
              onAbort()
              reject(new TransactionCanceled(transaction))
            }}
          />
        </div>
      )
    }

    renderElement(getComponent)
  })
}

export default openUniversalModal
